import * as allTypes from '../mutation-type';
import * as types from './client-mutation-type';
import { addClients, updateClient } from '@/api/clients/index';
import { GetPiecesJointesAsync } from '@/api/pieceJointes/index';
import cloneDeep from 'lodash/cloneDeep';
import generer from '@/services/client/genererTiers';
import savePiecesjointeClient from '@/services/piecesJointes/savePiecesjointeClient';

function initialState() {
  return {
    client: generer(),
    piecesJointes: [],
    elementId: null,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_PROPRIETY_CLIENT](state, { key, value }) {
    state.client[key] = value;
  },
  [types.SET_CLIENT](state, val) {
    state.client = val;
  },
  [types.VIDER_CHAMPS](state) {
    state.client = generer();
  },
  [types.VIDER_PJ](state) {
    state.piecesJointes = [];
  },
  [types.SET_PJ](state, files) {
    state.piecesJointes.push(...files);
  },
  [types.REMOVE_PJ](state, id) {
    const index = state.piecesJointes.findIndex(piece => piece.id === id);
    if (index >= 0) {
      state.piecesJointes.splice(index, 1);
    }
  },
  [types.SET_LOGO](state, logo) {
    const index = state.piecesJointes.findIndex(piece => piece.placeType === 'Logo');
    if (index >= 0) {
      state.piecesJointes.splice(index, 1);
    }
    if (logo) {
      state.piecesJointes.push(logo);
    }
  },
  [types.SET_ELEMENT_ID](state, id) {
    state.elementId = id;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  createClient: async({getters, state, dispatch, commit}) => {
    let client = cloneDeep(getters.client);
    const response = await addClients(client);
    const clientId = response.data.num;
    await savePiecesjointeClient(state.piecesJointes, clientId);
    commit(types.VIDER_PJ);
    await dispatch('contacts/createContact', clientId, { root: true });
    return response;
  },
  updateClient: async({getters, state, commit}) => {
    const client = cloneDeep(getters.client);
    client.id = getters.elementId;
    const response = await updateClient(client);
    await savePiecesjointeClient(state.piecesJointes, client.id);
    commit(types.VIDER_PJ);
    return response;
  },
  async loadPiecesJointes({ state }) {
    if (state.elementId) {
      return await GetPiecesJointesAsync(state.elementId);
    }
  },
  async setElementId({ commit, dispatch }, data) {
    if (data.id) {
      commit(types.SET_ELEMENT_ID, data.id);
      return dispatch('loadPiecesJointes');
    }
  },
};

const getters = {
  client: state =>  state.client,
  elementId: state => state.elementId,
  piecesJointes: state => {
    return state.piecesJointes;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
